import React from "react";
import styleClasses from "../../../containers/try2/try2.module.scss";
import * as CONSTANT from "../../../constants";
import { Col } from "react-bootstrap";
import kidsComboStyleClasses from "./kidsCombo.module.scss";
import { verifyStatus } from "../../../helpers/customizedItem/customizedItem.helper";
import NotAvailable from "../../Buttons/NotAvailable";
import { selectedBtnStyle } from "../../Molecules/Card/cardStyle";
import _clonedeep from 'lodash.clonedeep'
interface IKidsComboItem {
  disabledSelectedItem: boolean;
  selected: number;
  isFirstSelection: boolean;
  handleItemRemoval: (item: any, index: number) => void;
  index: number;
  requiredItem: any;
  pushToItemStack: (
    item: any,
    type: any,
    isFirstSelection?: boolean
  ) => void;
  orderType: string;
}

const KidsComboItemListing: React.FC<IKidsComboItem> = (props) => {
  const {
    disabledSelectedItem,
    selected,
    isFirstSelection,
    handleItemRemoval,
    index,
    requiredItem,
    pushToItemStack,
    orderType,
  } = props;

  const handleButtonClick = () => {
    if( !isItemActive() ) return
    if (!disabledSelectedItem)
      pushToItemStack(
        _clonedeep(requiredItem),
        CONSTANT.REQUIRED_MODIFIERS,
        isFirstSelection
      )
  }

  const buttonClasses = `btn item-select-btn mb-2 w-md-50 mt-2 ${styleClasses.selected_kids_combo
    } ${styleClasses.item_select_btn} ${selected && kidsComboStyleClasses.selected
    } ${disabledSelectedItem && kidsComboStyleClasses.disabled}`;

  const calories = () => {
    if (requiredItem?.calories > 0) {
      return <h6 className="f-s10 font-rale d-flex justify-content-between mb-0 lh-normal">
        {requiredItem.calories} cal
      </h6>
    }
  }
  
  const isItemActive = () => {
    if (verifyStatus(requiredItem, 'modifier_location') && (requiredItem.is_delivery || orderType !== CONSTANT.DELIVERY_ORDER_TYPE)) {
      return true;
    } else {
      return false;
    }
  }

  return (
 
    <Col
      xs="4"
      md="3"
      className="px-1 px-md-2 mb-2 mb-md-0 mb-2 mb-md-4"
      onClick={() => {
        if( !isItemActive() ) return
        if (isFirstSelection) handleButtonClick()
        else handleItemRemoval(requiredItem, index);
      }}
      key={requiredItem?.id}
      style={{ ...(!isItemActive() && { opacity: 0.7 }) }}
    >
     
        <div
          className={`add_on_item_wrap shadow-box d-flex flex-column h-100 cursor-pointer ${disabledSelectedItem && kidsComboStyleClasses.disabled
            }`}
          onClick={handleButtonClick}
          style={{
            ...(selected && {
              border: selected && "3px solid #0956A8",
            }),
          }}
          data-testid="kidsComboSelect"
        >
          <div
            className={`${styleClasses.items_image} mb-0 flex-fill d-flex align-items-center justify-content-center`}
          >
            <img
              src={`${CONSTANT.REACT_APP_CLOUD_FRONT}${requiredItem.image}`}
              className="img-fluid"
              alt={requiredItem.name}
            />
          </div>
          <div className="w-100 mx-auto mt-2">
            <h3 className={`${styleClasses.item_title} font-rale mb-2`}>
              {requiredItem.name}
            </h3>
            {isItemActive() ? (
              <button
                // handled button on top level div
                // onClick={handleButtonClick}
                type="button"
                className={`btn item-select-btn mb-2 w-md-50 mt-2 ${buttonClasses} ${styleClasses.kids_combo_selected}  ${disabledSelectedItem && kidsComboStyleClasses.kids_disabled
                  }`}
                data-testid="select-card-button"
              >
                {selected ? "Selected" : "Select"}
              </button>
            ) : (
              <NotAvailable selectedBtnStyle={selectedBtnStyle} />
            )}
            {calories()}
          </div>
        </div>
     
    </Col>
  

  );
};

export default KidsComboItemListing;
